import { NgModule } from '@angular/core';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { FooterComponent } from './footer/footer.component';
import { FrameWorkBodyComponent } from './frame-work-body/frame-work-body.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { MegaMenuComponent } from './mega-menu/mega-menu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UtilsModule } from '@otas/utils/utils.module';
import { UserInfoWrapperComponent } from 'app/user-info-wrapper/user-info-wrapper.component';
import { RouterModule } from '@angular/router';
import { LoaderSpinnerComponent } from './loader-spinner/loader-spinner.component';
import { BookingQueueIndicatorComponent } from 'app/shared/booking-queue-indicator/booking-queue-indicator.component';
import { RentalOverdueBellComponent } from 'app/shared/rental-overdue-bell/rental-overdue-bell.component';

@NgModule({
    declarations: [
        NavBarComponent,
        ToolbarComponent,
        MobileMenuComponent,
        NavMenuComponent,
        FooterComponent,
        FrameWorkBodyComponent,
        TopBarComponent,
        MegaMenuComponent, LoaderSpinnerComponent
    ],
    // providers: [MenuService],
    exports: [FrameWorkBodyComponent, LoaderSpinnerComponent], imports: [UtilsModule.forRoot(),
        FormsModule, RouterModule,
        ReactiveFormsModule, BookingQueueIndicatorComponent, RentalOverdueBellComponent], providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class CoreModule { }
